export enum LegacyRedirectTypes {
  PROFILE = 'profile',
  INVITATION = 'invitation',
  PROJECT = 'project',
  PACKAGE = 'package',
  PRESENTATION = 'presentation',
  ROLE = 'role',
  PROJECT_TALENT = 'project-talent',
}

export interface LegacyRedirectRouteParams {
  type: LegacyRedirectTypes;
  legacyInstance: string;
  legacyId: string;
  legacyPresentationGroupId?: string;
  legacyGroupId?: string;
  profileid: string;
  legacyUserName?: string;
}

export interface LegacyRedirectParamsResponse {
  legacyParams: LegacyRedirectParams;
}

export interface LegacyRedirectParams {
  id: string;
  inviationType: string;
  profileGuid: string;
  guid: string;
  projectId: string | number;
  presentationGroupId?: number;
  presentationFolderId?: number;
}

export interface LegacyRedirectComponentProps {
  redirectParams: LegacyRedirectParams;
}
